// Opening an operation (opCheck: fills the op panel and hands it to opPanel.js) and what the panel
// does with it: edit the work order's details, move operations to another work order, shrinkwrap
// stage labor, decline (and another user's delete), plus addOpen (the new op's row on the form).
// Moved out of app.js unchanged (docs/split-plan.md, session 7c).
import { parseDay } from './date-format';
import { resetEstimateState } from './estimates';
import { auth } from './initFirebase';
import { updatePhotoBadge } from './jobPhotos';
import { getCustomerRecord, getJobDataDB, updateJobInfo, updateJobStatus } from './jobWrites';
import { addLaborFirebase, createPopup, generateLaborTable, getJobData, getTodaysDate, updateLaborIndex } from './laborParts';
import { glow, recentInteraction } from './liveView';
import { usesDockmaster } from './marinaConfig';
import { getCurrentUserData } from './shellPages';
import { techsLabel } from './techNames';
import { escapeHTML, fetchIdToken, generateId, getDB, idbGet, idbPut, isShrinkwrapInstall, toastMessage, updateTimestamps, woLabel } from './utilities';
import { getWorkOrderNumberMove, syncWoContextStrip, updateWoOpsSummary } from './woForm';
import { searchCall, searchJobs } from './woSearch';
import { createNewTableRow, refreshWorkOrderRow, statusToneSlug, syncOpenOperationsPanel } from './woTable';

let shell = null;
export function setOpActionsDeps(deps) { shell = deps; }

export function addOpen(newOp) {

  var add = document.getElementById("Add")
  add.style.display = "flex"
  syncWoContextStrip();
  updateWoOpsSummary();
  resetEstimateState();
  setTimeout(() => {
    document.querySelector('.modal-inside').scrollTop = 0
  }, 100)


  if (!add.dataset.closeListenerBound) {
  add.dataset.closeListenerBound = '1';
  add.addEventListener('click', (e) => {
    if (e.target.id == 'exitAdd' || e.target.id == 'exitIcon') {
      add.style.display = "none"

      const currentYear = new Date().getFullYear();
      const nextYear = currentYear + 1;

      document.getElementById('general-work-order-button').style.display = 'flex'
      document.getElementById('customerDatabaseButton').style.display = 'flex'
      document.getElementById('search').focus()
      document.getElementById("work-order-form-customer-name").value = ""
      document.getElementById("work-order-form-customer-id").value = ""
      document.getElementById("work-order-form-customer-DMid").value = ""
      document.getElementById("work-order-form-customer-street").value = ""
      document.getElementById("work-order-form-customer-city").value = ""
      document.getElementById("work-order-form-customer-state").value = ""
      document.getElementById("work-order-form-customer-zip").value = ""
      document.getElementById("work-order-form-boat-name").value = ""
      document.getElementById("work-order-form-boat-id").value = ""
      document.getElementById("work-order-form-boat-DMid").value = ""
      document.getElementById("generalWorkOrder").value = ""
      document.getElementById("winterWorkOrder").value = ""
      document.getElementById("springWorkOrder").value = ""
      document.getElementById("shrinkwrapWorkOrder").value = ""
      document.getElementById('work-order-form-dates-launch-date').value = nextYear + "-04-01";
      document.getElementById('work-order-form-dates-haul-date').value = ""
      document.getElementById('work-order-form-customer-phone').value = "";
      document.getElementById('work-order-form-customer-email').value = "";
      document.getElementById('work-order-form-storage-confirm').checked = false
      document.getElementById('work-order-form-boat-mooring-number-slip').value = ''
      document.getElementById('work-order-form-boat-length').value = ''
      document.getElementById('work-order-form-boat-beam').value = ''
      document.getElementById('work-order-form-boat-combo').value = ''
      document.getElementById('work-order-form-boat-mooring-tag').value = ''
      document.getElementById('work-order-form-boat-bottom-color').value = ''
      document.getElementById('work-order-form-boat-bottom-paint').value = ''
      document.getElementById('work-order-form-boat-mast-length').value = ''
      document.getElementById('work-order-form-boat-engine-count').value = ''
      document.getElementById('work-order-form-boat-battery-count').value = ''
      document.getElementById('work-order-form-boat-engine-type').value = ''
      document.getElementById('work-order-form-boat-boat-type').value = ''
      document.getElementById('work-order-form-boat-fuel-type').value = ''
      document.getElementById('work-order-form-boat-fuel-capacity').value = ''
      document.getElementById('shortDesc').value = ""

      var Parent = document.getElementById('activeJobs')
      while (Parent.hasChildNodes()) {
        Parent.removeChild(Parent.firstChild)
      }

      document.getElementById('add-ops-btn').classList.add('hidden')
      document.getElementById('add-btn').classList.remove('hidden')

      let codeTable = document.getElementById('op-code-body').querySelectorAll('.op-code-row')

      // Scoped to #activeJobs — 'active' alone is a generic state class used
      // all over the app (nav flyout items, office-notes, tech-select modal,
      // op-type chips, etc.), so an unscoped getElementsByClassName picked up
      // whichever unrelated element on the page happened to be "active" and
      // read a garbage number off its id, crashing on the null lookups below.
      const activeJobs = document.getElementById('activeJobs').getElementsByClassName('active')

      while (activeJobs.length) {

        const number = activeJobs[0].id.at(-1)

        document.getElementById("category" + number).value = ""
        document.getElementById("opType" + number).value = ""
        document.getElementById('opCode' + number).value = ""
        document.getElementById("description" + number).value = ""
        document.getElementById("date" + number).value = ""
        document.getElementById("tech" + number).value = ""
        document.getElementById("status" + number).value = ""
        document.getElementById("job" + number).classList.remove('active')
        document.getElementById("job" + number).classList.add('inactive')
        document.getElementById('addJobButton' + number).classList.remove('hidden')
        document.getElementById('deleteJobButton' + number).classList.add('hidden')
        document.getElementById('jobExit' + number).classList.remove('hidden')
        document.getElementById('jobMinimize' + number).classList.add('hidden')

      }

      var Parent = document.getElementById('activeJobs')
      while (Parent.hasChildNodes()) {
        Parent.removeChild(Parent.firstChild)
      }

      document.getElementById('generalWorkOrder').scrollIntoView()
    }
  })
  }

  if (newOp) {
    return
  } else { document.getElementById('customerDatabaseButton').click() }
}

document.getElementById('exit-invoice').addEventListener('click', () => {
  document.getElementById('invoiceModal').style.display = 'none';
})

document.getElementById('receivePart').addEventListener('click', () => {
  let div = document.getElementById('receive-div');
  div.classList.toggle('hidden')
})

// Pure text builder for the op context strip — shared with billingModal() so it can open from
// anywhere (e.g. an operation row's "Bill Operation" button) without depending on the op-detail
// panel having been populated for this exact job. Reading those #opContext* elements back out of
// the DOM meant a billing modal opened without the panel showed whatever op was open last.
export function buildOpContextText(data, customerData) {
  const opDesc = (data.Description || '').split(':')[0].replace(/&amp;/g, '&');
  const phone = customerData?.Phone ? shell.formatPhoneNumber(customerData.Phone) : '';

  const opened = data.Start_Date ? parseDay(data.Start_Date) : null;
  const openedText = opened && !isNaN(opened) ? opened.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '';
  const techs = (data.Techs || '').toString();

  return {
    opDesc,
    boatName: (data.Boat_Name || '').toString().replace(/&amp;/g, '&'),
    workOrder: data.Work_Order ? woLabel(data.Work_Order) : '',
    customer: [data.Customer_Name, phone].filter(Boolean).join(' · '),
    opChip: data.OpCode || '',
    meta: [
      openedText ? `Opened ${openedText}` : '',
      techs ? `${techsLabel(techs)} on job` : ''
    ].filter(Boolean).join(' · '),
  };
}

// Populates the op-detail context strip (breadcrumb, boat/customer, op chip,
// opened date + techs, status pill) from the same `data`/`customerData` opCheck()
// already resolved — no separate fetch.
function updateOpContextStrip(data, customerData) {
  const ctx = buildOpContextText(data, customerData);

  // Work on the marina's own equipment links to the unit's page instead of a customer.
  const crumb = document.getElementById('opDetailCustomerCrumb');
  if (data.Equipment_Unit) {
    crumb.innerHTML = `<button type="button" class="op-equipment-link" data-equipment-unit="${escapeHTML(data.Equipment_Unit)}">Equipment · ${escapeHTML(data.Equipment_Unit)} ›</button>`;
  } else {
    crumb.textContent = data.Customer_Name || '';
  }
  document.getElementById('opDetailOpTitle').textContent = `Op ${data.OpCode} · ${ctx.opDesc}`;

  document.getElementById('opContextBoatName').textContent = ctx.boatName;
  document.getElementById('opContextWorkOrder').textContent = ctx.workOrder;
  document.getElementById('opContextCustomer').textContent = ctx.customer;
  document.getElementById('opContextOpChip').textContent = ctx.opChip;
  document.getElementById('opContextOpDesc').textContent = ctx.opDesc;
  document.getElementById('opContextMeta').textContent = ctx.meta;

  const pill = document.getElementById('opDetailStatusPill');
  const tone = statusToneSlug(data.Status);
  pill.className = 'op-detail-status-pill op-tone-' + tone;
  document.getElementById('opDetailStatusText').textContent = data.Status || '';
}

// The op panel's Category / Op type selects list the usual values, but an op can hold another
// (an op code's own type, e.g. Electrical or Canvas): add it so the select shows it instead of blank.
// An op with none shows the empty "Choose…" option.
function setSelectValue(el, value) {
  if (!el) return;
  if (value && ![...el.options].some(o => o.value === value)) el.add(new Option(value, value));
  el.value = value;
}

export async function opCheck(e, jobData, skip) {

  let data;
  let row;

  if (e) {
    e.stopPropagation();
    if (e.target.tagName === 'INPUT' || 
        e.target.tagName === 'BUTTON' ||
        e.target.parentElement.tagName === 'BUTTON' ||
        e.target.className === "customCheck" ||
        e.target.tagName === 'SELECT') {
      return
    }
    if (e.target.closest('.op-table-data-row')) {
      e.target.closest('.op-table-data-row').classList.add('selectedRow')
      row = e.target.closest('.op-table-data-row');
      shell.selectedJobRow = row;
    }

    if (e.target.closest('.op-table-data-row')) {
      e.target.closest('.op-table-data-row').classList.add('selectedRow')
      row = e.target.closest('.op-table-data-row');
      shell.selectedJobRow = row;
    }

    if (e.target.closest('.job-item')) {
      row = e.target.closest('.job-item');
    }

    if (e.target.closest('.haul-item')) {
      row = e.target.closest('.haul-item');
    }

    if(e.target.closest('.daily-item')){
      row = e.target.closest('.daily-item');
    }

    if (row && row.getAttribute('data-jobInfo')) {
      data = JSON.parse(row.getAttribute('data-jobInfo'));
    }

    if (row && row.getAttribute('data-jobInfo')) {
      data = JSON.parse(row.getAttribute('data-jobInfo'));
    };
  } else {
    data = jobData
  }

  shell.globalJobId = data.Job_ID
  shell.globalShrink = data

  // An operation must open no matter how sparse its customer/boat record is
  // (no mooring, no email, no boat record at all, blank job text fields).
  // Every customer/boat lookup below goes through `boat` (never
  // customerData.Boats[...] directly) and every string field through `str`,
  // so a missing value shows as blank instead of throwing and leaving the
  // click dead.
  const str = (v) => (v === undefined || v === null) ? '' : String(v);
  const description = str(data.Description);
  const customerName = str(data.Customer_Name);
  const boatName = str(data.Boat_Name).replace(/&amp;/g, '&');

  updatePhotoBadge(data.Job_ID, data);

  document.getElementById('currentJobId').value = data.Job_ID
  document.getElementById('jobId').value = data.Job_ID
  document.getElementById('updateName').value = customerName
  document.getElementById('currentName').value = customerName
  document.getElementById('currentCustomerName').textContent = customerName;
  document.getElementById('currentBoatName').textContent = str(data.Boat_Name);
  document.getElementById('currentOpenOp').innerHTML = "Op: " + description.split(":")[0]
  document.getElementById('currentShortDesc').value = str(data.Short_Description)
  document.getElementById('updateFirstName').value = customerName.split(', ')[1] || ''
  document.getElementById('updateLastName').value = customerName.split(', ')[0] || ''
  document.getElementById('updateCustomerId').value = str(data.Customer_ID)
  document.getElementById('updateBoat').value = boatName;
  document.getElementById('currentBoat').value = boatName;
  document.getElementById('updateBoatId').value = str(data.Boat_ID)


  let response = data.Customer_ID ? await shell.getCustomerDataById(data.Customer_ID, data.Boat_ID).catch(() => null) : null;
  let customerData = response?.customerData || null;
  const boat = customerData?.Boats?.[data.Boat_ID] || {};

  document.getElementById('updateEmail').value = customerData?.Email || '';
  document.getElementById('updateMooringNumber').value = boat.Mooring_Number || '';
  document.getElementById('updateComboKey').value = boat.Combo_Key || '';

  document.getElementById('updateWorkOrder').value = str(data.Work_Order)
  setSelectValue(document.getElementById('updateCategory'), str(data.Category))
  setSelectValue(document.getElementById('updateOpType'), str(data.Op_Type))
  document.getElementById('updateDescription').value = description.replace(/&amp;/g, '&');

  if(description.toLowerCase().includes('bottom paint')){

    const bottomPaintProduct = boat.Bottom_Paint_Product || 'No paint product on file';
    const bottomPaintColor = boat.Bottom_Paint_Color || 'No Paint Color';

    const boatLength = parseFloat(boat.Boat_Length) || 0;
    const boatBeam = parseFloat(boat.Boat_Beam) || 0;
              
        const quantity = (boatLength > 0 && boatBeam > 0) 
        ? parseFloat(((boatLength * boatBeam) * 0.85 / 350).toFixed(2))
        : 0; 

    document.getElementById('updateDescription').value = `Paint boat with one (1) coat of anti-fouling paint.

Paint: ${bottomPaintProduct}
Color: ${bottomPaintColor}
Qty: ${quantity} gallons`;
  }

  if(description.toLowerCase().includes('detail')){
    const detailingCompound = boat.Detailing_Compound;

    if(detailingCompound){
    document.getElementById('updateDescription').value = `${description}

Detailing Compound: ${detailingCompound}`;
    }else{
      document.getElementById('updateDescription').value = `${description}`;
    }
  }

  document.getElementById('updateTechNotes').value = data.Tech_Notes ? data.Tech_Notes : '';
  document.getElementById('currentJobDesc').value = description.replace(/&amp;/g, '&');
  document.getElementById('currentTech').value = data.Techs
  document.getElementById('updateStatus').value = data.Status
  shell.syncUpdateStatusTone();
  document.getElementById('currentStatus').value = data.Status
  document.getElementById('updateHours').value = data.Estimated_Hours
  document.getElementById('updateAmount').value = data.Charge
  document.getElementById('updateStartDate').value = data.Start_Date;
  document.getElementById('updateShortDesc').value = str(data.Short_Description).replace(/&amp;/g, '&');
  document.getElementById('updateOpCode').value = str(data.OpCode)
  document.getElementById('currentOpenOpCode').innerHTML = str(data.OpCode);
  document.getElementById('currentOpCode').value = data.OpCode
  updateOpContextStrip(data, customerData);
  document.getElementById("currentWorkOrder").value = data.Work_Order
  document.getElementById("work-order-form-dates-launch-date").value = data.Launch_Date
  document.getElementById("work-order-form-dates-haul-date").value = data.Haul_Date
  document.getElementById('partWorkOrder').value = data.Work_Order
  document.getElementById('currentCategory').value = data.Category
  document.getElementById('currentOpType').value = data.Op_Type
  document.getElementById('currentCustomerId').value = data.Customer_ID
  document.getElementById('currentBoatId').value = data.Boat_ID
  document.getElementById('partJobId').value = data.Job_ID

  if (data.Status == 'Hold') {
    document.getElementById('holdButton').style.display = 'none'
    document.getElementById('removeHoldButton').style.display = 'block'
  } else {
    document.getElementById('holdButton').style.display = 'block'
  }

  if(description.toLowerCase().includes('shrinkwrap boat') && data.Status !== 'Vents Installed'){
    document.getElementById('shrinkwrap-menu-button').style.display = 'flex';
  }else{
    document.getElementById('shrinkwrap-menu-button').style.display = 'none';
  }

document.getElementById('Update').classList.add('active')

if(data.Status === 'Complete' || data.Status === 'Ready to Bill' || data.Status === 'Closed'){
  document.querySelector('.job-complete-button').style.display = "none";
  document.getElementById('open-billing').style.display = "block";
}else{
  document.querySelector('.job-complete-button').style.display = "block";
  document.getElementById('open-billing').style.display = "none";
}

if (isShrinkwrapInstall(data)){
  document.getElementById('shrinkwrap-included').classList.remove('hidden');
}else{
  document.getElementById('shrinkwrap-included').classList.add('hidden');
}

  let oldButtons = document.querySelectorAll('.map-button');
  if (oldButtons) {
    oldButtons.forEach(button => button.remove());
  };

  let mapButton = document.createElement('button')
  mapButton.id = 'showMap'
  mapButton.className = 'map-button'
  mapButton.innerHTML = 'Show on Map'
  mapButton.addEventListener('click', () => {
    document.getElementById('mapView').style.display = 'flex'
  })
  mapButton.setAttribute('data-boatId', data.Boat_ID)
  /* document.getElementById('operations-field').appendChild(mapButton) */

  // Also refresh when the Labor & Parts panel is already open (e.g.
  // switching between sibling operations via the op-rail nav while it's
  // showing) — otherwise it keeps displaying the previous operation's
  // labor/parts entries under the new operation's header.
  const statusTableOpen = document.getElementById('statusTable')?.style.display === 'flex';
  if (skip === true || statusTableOpen) {
  document.getElementById('entryButton').click();
  document.getElementById('Update').classList.remove('active');
  }

  // opPanel.js rebuild seam — renderOpPanel() owns 100% of the new panel's
  // visual rendering and must run last, after every field above is populated
  // and every side effect (context strip, button visibility, etc.) has run.
  // Do not add code after this line without considering whether it needs to
  // run before renderOpPanel() sees `data`/`customerData`.
  shell.renderOpPanel(data, customerData);

}

// Live (docs/live-updates-plan.md): another user changed the operation open in the panel. Fields
// this user hasn't touched take the new value (and glow); a field being edited, or edited and not
// yet saved, is left alone. The hidden state the panel's actions read follows too, and the status
// strip / banners / tiles redraw in place.
export function refreshOpenOpPanel(job) {
  const panel = document.getElementById('Update');
  if (!panel || !panel.classList.contains('active')) return;
  if (!job || document.getElementById('currentJobId')?.value !== job.Job_ID) return;
  const str = (v) => (v === undefined || v === null) ? '' : String(v);
  const changed = [];
  const setField = (id, value) => {
    const el = document.getElementById(id);
    if (!el) return;
    const base = el.dataset.opFieldLastCommitted ?? el.value;
    if (document.activeElement === el || el.value !== base) return; // being edited: leave it
    if (el.value === value) return;
    if (el.tagName === 'SELECT') setSelectValue(el, value); else el.value = value;
    el.dataset.opFieldLastCommitted = el.value;
    changed.push(el.closest('.op-field-wrap') || el);
  };
  setField('updateShortDesc', str(job.Short_Description).replace(/&amp;/g, '&'));
  setField('updateCategory', str(job.Category));
  setField('updateOpType', str(job.Op_Type));
  const desc = str(job.Description);
  // Bottom paint / detailing descriptions are shown with the boat's paint or compound added; leave those.
  if (!/bottom paint|detail/i.test(desc)) setField('updateDescription', desc.replace(/&amp;/g, '&'));
  setField('updateTechNotes', str(job.Tech_Notes));
  setField('updateHours', str(job.Estimated_Hours));
  setField('updateAmount', str(job.Charge));
  setField('updateStartDate', str(job.Start_Date));
  const hidden = (id, v) => { const el = document.getElementById(id); if (el) el.value = v; };
  hidden('currentTech', str(job.Techs));
  hidden('updateStatus', str(job.Status));
  hidden('currentStatus', str(job.Status));
  hidden('currentJobDesc', desc.replace(/&amp;/g, '&'));
  hidden('updateOpCode', str(job.OpCode));
  shell.syncUpdateStatusTone();
  shell.refreshOpPanelLive(job);
  if (!recentInteraction()) glow(changed.map(el => { el.dataset.key = el.querySelector?.('.op-field')?.id || el.id || 'field'; return el; }));
}

export async function editWorkOrderData(opData) {

  const moveOperationSelectContainer = document.getElementById('moveOperationSelectContainer');
  moveOperationSelectContainer.innerHTML = ''; // Clear existing checkboxes

  let operationData = null;

  if(opData){
    operationData = opData;
  }else{

    const operations = Array.from(document.querySelectorAll('#operations-table .op-table-data-row'));

    // Map operations to an array of objects with parsed data
    operationData = operations.map(operation => {
      const data = JSON.parse(operation.getAttribute('data-jobInfo'));
      return {
        opCode: data.OpCode,
        description: (data.Description || '').split(':')[0],
        jobId: data.Job_ID,
        workOrder: data.Work_Order,
        data
      };
    });

    }

  console.log(operationData);

  // Sort operations by OpCode
  operationData.sort((a, b) => a.opCode.localeCompare(b.opCode));

  // Render sorted operations
  operationData.forEach(({ opCode, description, jobId, workOrder, data }) => {
    // Create a checkbox input
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.value = opCode;
    checkbox.id = `operation-${opCode}`;
    checkbox.setAttribute('data-jobid', jobId);
    checkbox.setAttribute('data-workorder', workOrder);
    checkbox.setAttribute('data-jobinfo', JSON.stringify(data));

    // Create a label for the checkbox
    const label = document.createElement('p');
    label.htmlFor = `operation-${opCode}`;
    label.textContent = `${opCode} - ${description}`;

    // Wrap checkbox and label in a container
    const div = document.createElement('div');
    div.classList.add('checkbox-item');
    div.appendChild(checkbox);
    div.appendChild(label);

    moveOperationSelectContainer.appendChild(div);
  });

  const jobData = operationData[0].data;
  const currentShortDescription = jobData.Short_Description;
  const currentStartDate = jobData.Start_Date;
  const customerData = (await getCustomerRecord(jobData.Customer_ID).catch(() => null)) || {};

  document.getElementById('update-work-order-customer-id').value = jobData.Customer_ID;
  document.getElementById('update-work-order-boat-id').value = jobData.Boat_ID;
  document.getElementById('update-work-order-customer-DMid').value = customerData.DM_Customer || '';

  document.getElementById('customerName').textContent = jobData.Customer_Name;
  document.getElementById('boatName').textContent = jobData.Boat_Name;
  document.getElementById('workOrderNumber').innerHTML = jobData.Work_Order;

  document.getElementById('updateWorkOrderShortDescription').value = currentShortDescription;
  document.getElementById('updateWorkOrderStartDate').value = currentStartDate;

  document.getElementById('jobInfoModal').style.display = 'flex';
}

document.getElementById('move-operation-work-order-button').addEventListener('click',async () => {
  const customerId = document.getElementById('update-work-order-customer-id').value;
  const boatId = document.getElementById('update-work-order-boat-id').value;
  const customerData = (await getCustomerRecord(customerId).catch(() => null)) || {};
  const dmCustomerId = customerData.DM_Customer;
  const dmBoatId = customerData.Boats?.[boatId]?.DM_Boat;
  const clerkId = shell.globalUserData[localStorage.getItem('currentUserId')].clerkId;
  const type = 'R';
  const title = document.getElementById('move-operation-work-order-title').value;

  getWorkOrderNumberMove(clerkId, dmCustomerId, dmBoatId, type, title)
  .then(newWorkOrder => {
  document.getElementById('moveOperationWorkOrder').value = newWorkOrder;
  return newWorkOrder;
  })
  .then((newWorkOrder) => {
  if (usesDockmaster()) shell.deleteOperationDM(newWorkOrder, "CREATE");
  });

});

document.getElementById('move-operations-button').addEventListener('click', async () => {
  const moveOperationSelect = document.getElementById('moveOperationSelectContainer');
  const selectedOperations = moveOperationSelect.querySelectorAll('input[type="checkbox"]:checked');
  const customerId = document.getElementById('update-work-order-customer-id').value;
  const customerData = await getCustomerRecord(customerId);
  const clerkId = shell.globalUserData[localStorage.getItem('currentUserId')].clerkId;
  const newWorkOrder = document.getElementById('moveOperationWorkOrder').value;
  

  let operationsByWorkOrder = {};

  if (selectedOperations.length === 0) {
    toastMessage('Please select at least one operation to move.', 'red');
    return;
  }

  for (const operation of selectedOperations) {
    const jobId = operation.getAttribute('data-jobid');
    const workOrder = operation.getAttribute('data-workorder');
    const opCode = operation.value;

    await shell.deleteOperationDM(workOrder, opCode);

    document.querySelector(`.op-table-data-row[data-id="${jobId}"]`).remove();

    const jobData = JSON.parse(operation.getAttribute('data-jobinfo'));

    if (!operationsByWorkOrder[newWorkOrder]) {
      operationsByWorkOrder[newWorkOrder] = [];
    }

    operationsByWorkOrder[newWorkOrder].push(jobData.Status);

    let type;
    if (jobData.Status.toLowerCase() === 'internal') {
      type = 'I';
    } else {
      type = 'R';
    }

    const serviceLog = {
      DMCustomer: customerData?.DM_Customer || '',
      Work_Order: newWorkOrder,
      type: type,
      LocationCode: "1",
      clerkId: clerkId,
      Long_Description: jobData.Description,
      Description: jobData.Description,
      Short_Description: jobData.Short_Description_DM ? jobData.Short_Description_DM : jobData.Short_Description,
      OpCode: jobData.OpCode,
    };

    await shell.updateWorkOrderDM(serviceLog);
    await updateJobInfo(jobId, 'Work_Order', newWorkOrder);
  }

  if (document.querySelector('#table-content .table-item[data-workorder="' + newWorkOrder + '"]')) {
    console.log(document.querySelector('#table-content .table-item[data-workorder="' + newWorkOrder + '"]'));
    return;
  } else {
    const data = JSON.parse(selectedOperations[0].getAttribute('data-jobinfo'));
    const opCount = selectedOperations.length;
    data.Work_Order = newWorkOrder;
    data.Short_Description = document.getElementById('move-operation-work-order-title').value;
    
    await createNewTableRow(data, opCount);
  }

  document.getElementById('jobInfoModal').style.display = 'none';
});

document.getElementById('update-work-order-button').addEventListener('click', async () => {
  const shortDescription = document.getElementById('updateWorkOrderShortDescription').value;
  const startDate = document.getElementById('updateWorkOrderStartDate').value;

    const operationList = document.getElementById('operations-table').querySelectorAll('.op-table-data-row');
    operationList.forEach(async operation => {
      const jobId = operation.getAttribute('data-id');
      if(jobId){
        await updateJobInfo(jobId, 'Start_Date', startDate);
        await updateJobInfo(jobId, 'Short_Description', shortDescription);

        if(startDate.split('-')[0] === new Date().getFullYear().toString()){
          operation.querySelector('.op-start-date-info').innerHTML = '<strong>Start Date:</strong> ' + startDate.split('-')[1] + '-' + startDate.split('-')[2];
        }else{
          operation.querySelector('.op-start-date-info').innerHTML = '<strong>Start Date:</strong> ' + startDate;
        }
      }

    });

    document.getElementById('jobInfoModal').style.display = 'none';

  });


document.getElementById('shrinkwrap-menu-button').addEventListener('click', async () => {
  const jobId = document.getElementById('currentJobId').value;
  const jobData = await getJobData(jobId)
  const customerData = await shell.getCustomerDataById(jobData.Customer_ID, jobData.Boat_ID).catch(() => null);
  const boatData = customerData?.customerData?.Boats?.[jobData.Boat_ID] || {};
  let currentStatus;

  const buttons = document.querySelector('#shrinkwrap-menu-inside').querySelectorAll('button');
  buttons.forEach(button => { button.style.display = 'block'});

  if( (boatData.Date_Hauled || '').split('-')[0] === new Date().getFullYear().toString() ){
      currentStatus = 'Ready to Frame'
     }

  if( jobData.Status === 'Framed' ){
    document.getElementById('boat-framed').style.display = 'none';
  }

  if( jobData.Status === 'Vacuumed' ){
    document.getElementById('boat-framed').style.display = 'none';
    document.getElementById('boat-vacuumed').style.display = 'none';
  }

  if( jobData.Status === 'Covered' ){
    document.getElementById('boat-framed').style.display = 'none';
    document.getElementById('boat-vacuumed').style.display = 'none';
    document.getElementById('boat-covered').style.display = 'none';
  }

  if( jobData.Status === 'Tightened' ){
    document.getElementById('boat-framed').style.display = 'none';
    document.getElementById('boat-vacuumed').style.display = 'none';
    document.getElementById('boat-covered').style.display = 'none';
    document.getElementById('boat-tightened').style.display = 'none';
  }

  if( jobData.Status === 'Awaiting Review'){
    const checkboxes = document.querySelector('.shrinkwrap-menu-content').querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.checked = true;
      checkbox.disabled = true;
    });
  }
  document.getElementById('shrinkwrap-menu').style.display = 'flex';
});

function showHoursPopup(button) {

  return new Promise((resolve, reject) => {
    const popup = createPopup('Enter Hours');
    const input = document.createElement('input');
    input.type = 'number';
    input.placeholder = 'Hours';
    input.className = 'shrinkwrap-hours-input';
    popup.appendChild(input);

    const confirmButton = document.createElement('button');
    confirmButton.textContent = 'Submit';
    confirmButton.classList.add('pop-up-submit-button');
    popup.appendChild(confirmButton);

    const cancelButton = document.createElement('button');
    cancelButton.textContent = 'Cancel';
    cancelButton.classList.add('pop-up-cancel-button');
    popup.appendChild(cancelButton);

    document.body.appendChild(popup);
    input.focus();

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        popup.style.display = 'none';
        button.style.display = 'none';
        resolve(input.value);
      }
    });

    confirmButton.onclick = () => {
      popup.style.display = 'none';
      button.style.display = 'none';
      resolve(input.value);
    };

    cancelButton.onclick = () => {
      popup.style.display = 'none';
      input.value = ''; 
      reject('User cancelled');
    };

  });
}

document.getElementById('shrinkwrap-menu-inside').addEventListener('click', async (e) => {
  e.stopPropagation();

  if (e.target.tagName === 'BUTTON') {
    const currentButton = e.target;
    const previousButton = currentButton.previousElementSibling;

    if (previousButton && window.getComputedStyle(previousButton).display !== 'none') {
   
      const visibleChild = Array.from(currentButton.parentElement.children).find(child => window.getComputedStyle(child).display !== 'none');
      if (visibleChild) {
        toastMessage(`Please check off "${visibleChild.textContent}" before proceeding.`,'red');
        return;
      }
    }

    const jobId = document.getElementById('currentJobId').value;
    const hours = await showHoursPopup(currentButton);
    await shrinkwrapLabor(jobId, currentButton.getAttribute('data-type'), hours);
  }
});

export async function shrinkwrapLabor(jobId, laborType, hours) {

  try {
      // localStorage.userInfo is only ever populated by checkAuthState()
      // (app.js), a separate lazy path from the normal login boot flow —
      // not guaranteed to have run yet. Fall back to the live Firebase auth
      // user (same object shape, has .displayName) rather than crashing.
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null') || auth.currentUser;
      const currentTech = (userInfo && userInfo.displayName ? userInfo.displayName.split(' ')[0] : 'Unknown');
      const entryId = await generateId();
      const date = await getTodaysDate();
      let status = ''

      const frameLabor = "Built shrinkwrap frame. Secured frame to boat using shrinkwrap string.  Placed carpet under all supports.";
      const vacuumLabor = "Checked bilge and all compartments for water.  Vacuumed all compartments.";
      const coveredLabor = "Covered boat with shrinkwrap.  Secured shrinkwrap under string and secured all seams with shrinkwrap tape.";
      const tightenLabor = "Tightened shrinkwrap.  Inspected seams and checked for any holes or tears.";
      const ventLabor = "Installed shrinkwrap vents to allow for air circulation.";

      let labor = '';

      if(laborType === 'Framed'){
        labor = frameLabor;
        status = 'Framed';
      }

      if(laborType === 'Vacuumed'){
        labor = vacuumLabor;
        status = 'Vacuumed';
      }

      if(laborType === 'Covered'){
        labor = coveredLabor;
        status = 'Covered';
      }

      if(laborType === 'Tightened'){
        labor = tightenLabor;
        status = 'Tightened';
      }

      if(laborType === 'Vents Installed'){
        labor = ventLabor;
        status = 'Awaiting Review';
      }

    const laborData = {
      'Description': labor,
      'Hours': hours,
      'Category': 'Winterizing',
      'Op_Type': 'Shrinkwrap',
      'Job_ID': jobId,
      'ID': entryId,
      'Boat_Name': document.getElementById('updateBoat').value,
      'Customer_Name': document.getElementById('updateName').value,
      'Time_Submitted': date,
      'Work_Order': document.getElementById('updateWorkOrder').value,
      'Tech': currentTech
    }

    await addLaborFirebase(laborData);
    await updateLaborIndex(jobId, laborData);
    updateTimestamps('jobData', 'data');
    updateJobStatus(jobId, status);

    document.getElementById('updateStatus').value = status;
    shell.syncUpdateStatusTone();

      if(shell.selectedJobRow){
        shell.selectedJobRow.style.backgroundColor = 'rgb(236, 237, 175)';
      }

      if(shell.activeTableRow){
        { const pill = shell.activeTableRow.querySelector('.status-info'); if (pill) pill.style.backgroundColor = 'yellow'; }
      }
    
    toastMessage('Labor Submitted', 'green');
    generateLaborTable(jobId);

  } catch (error) {
    console.error('Failed to submit labor', error);
    toastMessage('Failed to submit labor', 'red');
  }
}

document.getElementById("exitTech").addEventListener('click', () => {
  document.getElementById("techTable").style.display = "none"
})

document.getElementById("exitWorkOrder").addEventListener('click', () => {
  document.getElementById("woTable").style.display = "none"
})

export async function deleteOperation() {
  const jobId = document.getElementById('currentJobId').value;
  const jobInfo = await getJobDataDB(jobId);
  const WOId = jobInfo.Work_Order;
  const operation = jobInfo.OpCode;

  const result = await shell.openDeclineConfirmDialog();
  if (!result) return;
  const declineNote = result.note;

  const user = await getCurrentUserData();
  const idToken = await fetchIdToken();

  // Collaboration: the panel may be behind. Don't decline what someone else just finished, billed
  // or declined without saying so.
  const live = await fetch(`${shell.currentURL}/data/${jobId}.json?auth=${idToken}`).then(r => (r.ok ? r.json() : null)).catch(() => null);
  if (live && live.Status === 'Declined') { toastMessage(`${live.Declined_User || 'Someone else'} already declined this operation.`, 'blue', 4000); return; }
  if (live && ['Complete', 'Ready to Bill', 'Closed'].includes(live.Status) && live.Status !== jobInfo.Status
    && !confirm(`Someone just marked this operation ${live.Status}.

Decline it anyway?`)) return;

  const updates = {
    Status: 'Declined',
    Declined_Note: declineNote,
    Declined_User: (user && (user.displayName || user.email)) || 'Unknown',
    Declined_Date: await shell.formatDate(),
    DM_Delete_Pending: true
  };

  const jobUrl = `${shell.currentURL}/data/${jobId}.json?auth=${idToken}`;
  const lastUpdatedUrl = `${shell.currentURL}/data/lastUpdated.json?auth=${idToken}`;

  try {
    const saved = await fetch(jobUrl, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(updates) });
    if (!saved.ok) throw new Error(`HTTP ${saved.status}`); // a refused write must not look declined
    await fetch(lastUpdatedUrl, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ".sv": "timestamp" }) });

    try {
      const existing = await idbGet('jobData', jobId);
      if (existing) await idbPut('jobData', { ...existing, ...updates });
    } catch (_) {}

    const selectedRows = document.querySelectorAll('.selectedRow');
    const opTable = document.getElementById('operations-table');
    selectedRows.forEach(row => opTable && opTable.removeChild(row));
    selectedRows.forEach(row => row.classList.remove('selectedRow'));
    const jobEl = document.querySelector(`#jobList .job-item[data-id="${jobId}"]`);
    if (jobEl) jobEl.remove();
    searchCall(); searchJobs();
    if (shell.jobsByWorkOrder && shell.jobsByWorkOrder.has(WOId)) {
      const arr = shell.jobsByWorkOrder.get(WOId);
      const idx = arr.findIndex(j => j.Job_ID === jobId || j.id === jobId);
      if (idx >= 0) arr[idx] = { ...arr[idx], ...updates };
    }
    // Handles removing the now-empty work order row/panel if this was its last
    // active operation — see refreshWorkOrderRow() for why that check lives there.
    refreshWorkOrderRow(WOId);

    // The operation is already gone from the work order at this point — close the
    // op detail view and confirm right away instead of leaving it open on stale data
    // while the (often slow) Dockmaster sync below runs.
    document.getElementById('statusTable').style.display = 'none';
    document.getElementById('Update').classList.remove('active');
    toastMessage('Operation declined', 'green');
  } catch (err) {
    console.error('Decline write failed before DM attempt:', err);
    toastMessage('Failed to decline operation', 'red');
    return;
  }

  let dmOk = true;
  try {
    await shell.deleteOperationDM(WOId, operation);
  } catch (err) {
    dmOk = false;
  }

  const postDM = dmOk
    ? { DM_Delete_Pending: false, DM_Deleted: true, DM_Deleted_At: await shell.formatDate() }
    : { DM_Delete_Pending: false, DM_Deleted: false, DM_Delete_Error: { code: 500, at: await shell.formatDate(), WOId, Operation: operation } };

  try {
    await fetch(jobUrl, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(postDM) });
    await fetch(lastUpdatedUrl, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ".sv": "timestamp" }) });
    try {
      const existing = await idbGet('jobData', jobId);
      if (existing) await idbPut('jobData', { ...existing, ...postDM });
    } catch (_) {}
  } catch (err) {
    console.error('Failed to record DM status:', err);
  }

  if (!dmOk) {
    toastMessage('DockMaster sync failed for the declined operation; recorded for follow-up', 'yellow');
  }
}



export async function deleteOperationOtherUser(job) {

      try{
        deleteDataFromOpenDatabase(job.Job_ID);
        document.querySelector(`#jobList .job-item[data-id="${job.Job_ID}"]`)?.remove();

        if (shell.jobsByWorkOrder && shell.jobsByWorkOrder.has(job.Work_Order)) {
          const arr = shell.jobsByWorkOrder.get(job.Work_Order).filter(j => j.Job_ID !== job.Job_ID && j.id !== job.Job_ID);
          arr.length ? shell.jobsByWorkOrder.set(job.Work_Order, arr) : shell.jobsByWorkOrder.delete(job.Work_Order);
        }

        document.getElementById('operations-table')?.querySelector(`.op-table-data-row[data-id="${job.Job_ID}"]`)?.remove();
        // Its last operation: the work order has nothing left to show (refreshWorkOrderRow skips
        // a work order with no operations, so its row stayed until a reload).
        const woRow = shell.jobsByWorkOrder && !shell.jobsByWorkOrder.has(job.Work_Order)
          && document.querySelector(`#table-content .table-item[data-workorder="${CSS.escape(String(job.Work_Order))}"]`);
        if (woRow) { shell.removeOperationDetails(woRow); woRow.remove(); }
        refreshWorkOrderRow(job.Work_Order);
        syncOpenOperationsPanel(job.Work_Order);
        // Someone else deleted the operation this user has open.
        if (document.getElementById('Update')?.classList.contains('active') && document.getElementById('currentJobId')?.value === job.Job_ID) {
          toastMessage('This operation was just deleted by someone else.', 'red');
        }

      }catch(error) {
        console.log("Failed to delete labor record", 'red');
      };

}

async function deleteDataFromOpenDatabase(jobId) {
  try {
    const db = await getDB();
    const transaction = db.transaction("jobData", "readwrite");
    const store = transaction.objectStore("jobData");

    await new Promise((resolve, reject) => {
      const req = store.delete(jobId);
      req.onsuccess = () => resolve();
      req.onerror = (error) => {
        console.error("Error deleting job data", error);
        reject(error);
      };
    });
  } catch (error) {
    console.error("Error opening database", error);
  }
}
